import { createContext, useContext } from 'react';
import { ReferralThemeRevision } from 'referral-types';

type ReferralThemeRevisionContextType = {
  referralThemeRevision?: ReferralThemeRevision;
};

export const ReferralThemeRevisionContext = createContext<ReferralThemeRevisionContextType | undefined>(undefined);

export const useReferralThemeRevision = () => {
  const context = useContext(ReferralThemeRevisionContext);
  if (context === undefined) {
    throw new Error('useReferralThemeRevision must be used within a PageRevisionProvider');
  }
  return context;
};
